import SuReviewsWidget from "../../components/reviews/SuReviewsWidget";

const ReviewsPage = () => {
  return (
    <div className="w-full h-full p-[20px]">
      <h1 className="text-[22px] font-semibold text-[#1a1a1a] mb-[20px] font-outfit">
        Reviews
      </h1>
      <SuReviewsWidget />
    </div>
  );
};

export default ReviewsPage;
